import { motion } from '@eversports/react-components/design-tokens/motion'
import { SimpleFlex } from '@eversports/react-components/primitives/Flex'
import Text from '@eversports/react-components/primitives/Text'

import { Localized } from '../../localization/react'
import { PriceTableItem } from '../../typings/PriceTable'

import SummaryItem from './SummaryItem'

interface Props {
  items?: Array<PriceTableItem>
  isSettleWithAConfirmWithOption: boolean
}

const SummaryItems = ({ items, isSettleWithAConfirmWithOption }: Props) =>
  items && items.length > 0 ? (
    <SimpleFlex flexDirection="column">
      {isSettleWithAConfirmWithOption && (
        <Text size="small" marginBottom={'default'}>
          <Localized id="summary-participate-with" />:
        </Text>
      )}
      {items.map((item, index) => (
        <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} key={index}>
          <SummaryItem item={item} key={index} />
        </motion.div>
      ))}
    </SimpleFlex>
  ) : (
    <Text>
      <Localized id="summary-choose-product" />
    </Text>
  )

export default SummaryItems
